import { Button } from "@/components/ui/button";
import * as Icons from "lucide-react";
import { FieldEditor, blankLike, tid } from "./FieldEditor";

// Shape of a new item when the list is still empty (matches what brugo.in reads),
// so e.g. the first promotion banner or testimonial gets proper fields incl. its image.
const TEMPLATES = [
  [/(^|\.)promo[a-z]*\.items$/i, { image: "", headline: "", copy: "", cta: "", to: "", starts: "", ends: "", dark: false }],
  [/(^|\.)testimonials\.items$/i, { quote: "", name: "", area: "", service: "", rating: 5, image: "", video: "", poster: "" }],
  [/(^|\.)tiles$/i, { slug: "", name: "", headline: "", to: "", image: "" }],
];
const templateFor = (path) => TEMPLATES.find(([re]) => re.test(path))?.[1];

export function ArrayEditor({ value, onChange, path, template, hints }) {
  const move = (i, d) => { const a = [...value]; [a[i], a[i + d]] = [a[i + d], a[i]]; onChange(a); };
  // New entry: the website's field guide first (exact fields it reads), else a known template, else the shape of the first entry.
  const add = () => onChange([...value, template ? { ...template } : value.length ? blankLike(value[0]) : (templateFor(path) ? { ...templateFor(path) } : "")]);
  return (
    <div className="space-y-2" data-testid={`cms-array-${tid(path)}`}>
      {value.map((item, i) => (
        <div key={i} className="rounded-lg border border-border p-3 bg-background">
          <div className="flex items-center justify-between mb-2">
            <span className="text-[10px] font-mono text-muted-foreground">#{i + 1}</span>
            <div className="flex gap-1">
              <Button size="icon" variant="ghost" className="h-6 w-6" disabled={i === 0} onClick={() => move(i, -1)} data-testid={`cms-up-${tid(path)}-${i}`}><Icons.ArrowUp className="h-3 w-3" /></Button>
              <Button size="icon" variant="ghost" className="h-6 w-6" disabled={i === value.length - 1} onClick={() => move(i, 1)} data-testid={`cms-down-${tid(path)}-${i}`}><Icons.ArrowDown className="h-3 w-3" /></Button>
              <Button size="icon" variant="ghost" className="h-6 w-6 text-red-600" onClick={() => onChange(value.filter((_, j) => j !== i))} data-testid={`cms-remove-${tid(path)}-${i}`}><Icons.Trash2 className="h-3 w-3" /></Button>
            </div>
          </div>
          <FieldEditor name={`${i}`} value={item} path={`${path}.${i}`} hints={hints} onChange={(v) => onChange(value.map((x, j) => (j === i ? v : x)))} />
        </div>
      ))}
      <Button size="sm" variant="outline" className="h-7 gap-1" onClick={add} data-testid={`cms-add-${tid(path)}`}><Icons.Plus className="h-3 w-3" /> Add item</Button>
    </div>
  );
}
